export default function () {
  return {
    paths: [],
    pathsByIdArgomento: {},
    userPaths: [],
    selectedPaths: []
  }
}
